<template>
  <div class='EnbLink02'
  @click="$router.push(data.path)"
  @mouseenter="emit(true)"
  @mouseleave="emit(false)"
  :style="{ color: Prefes.nave.corFont }"
  >
    {{ data.text }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'EnbLink02',
  props: {
    data: {
      type: Object,
      default: () => ({ text: 'link', path: '/' })
    },
    toggleCateg: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    emit (bool) {
      if(this.data.text === 'Produtos') {
        this.$emit('update:showCateg', bool)
      }
    }
  }
}
</script>

<style scoped>
.EnbLink02 {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 1%;
  padding-right: 1%;
  cursor: pointer;
  color: #666666;
}

.EnbLink02:hover {
  background-color: #EEEEEE;
}
</style>
